import { render } from "./thirteenPage.vue?vue&type=template&id=44364360&scoped=true"
import script from "./thirteenPage.vue?vue&type=script&lang=js"
export * from "./thirteenPage.vue?vue&type=script&lang=js"

import "./thirteenPage.vue?vue&type=style&index=0&id=44364360&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44364360"]])

export default __exports__